import axios from "axios";
import qs from "qs";

axios.interceptors.request.use(
  config => {
    // loading
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.resolve(error.response);
  }
);

function checkStatus(response) {
  return response;
  // loading
  // 如果http状态码正常，则直接返回数据
  // if (
  //   response &&
  //   (response.status === 200 ||
  //     response.status === 304 ||
  //     response.status === 400)
  // ) {
  //   return response;
  //   // 如果不需要除了data之外的数据，可以直接 return response.data
  // }
  // 异常状态下，把错误信息返回去
  // return {
  //   status: -404,
  //   msg: "网络异常"
  // };
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res && res.status === -404) {
    // alert("没有更多数据")
    console.log(res.status);
  }
  if (!res.data) {
    console.log("empty response body");
  }
  return res;
}

export default {
  post(url, data, headers) {
    return axios({
      method: "post",
      baseURL: "/api/",
      url,
      data: data,
      timeout: 10000,
      headers: headers
    })
      .then(response => {
        return checkStatus(response);
      })
      .then(res => {
        return checkCode(res);
      });
  },
  get(url, params, headers) {
    // headers = Object.assign(headers, { "X-Requested-With": "XMLHttpRequest" });
    return axios({
      method: "get",
      baseURL: "/api/",
      url,
      params, // get 请求时带的参数
      timeout: 10000,
      headers: headers
    })
      .then(response => {
        return checkStatus(response);
      })
      .then(res => {
        return checkCode(res);
      });
  },
  delete(url, data, headers) {
    return axios({
      method: "delete",
      baseURL: "/api/",
      url,
      data: data,
      timeout: 10000,
      headers: headers
    })
      .then(response => {
        return checkStatus(response);
      })
      .then(res => {
        return checkCode(res);
      });
  }
};



// WEBPACK FOOTER //
// ./src/api/http.js